export default __webpack_public_path__ + "ee9b2083071077c155c837cbd622ebf8.svg";